import jAiList from '@/views/ai/jAiList';
import jAiDetail from '@/views/ai/jAiDetail';

import auth from '@/middleware/auth';
import log from '@/middleware/log';
import admin from '@/middleware/admin';

export default [
  {
    path: '/ai',
    name: 'jAiList',
    component: jAiList,
    meta: {
      title: 'Artificial Intelligence',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
  {
    path: '/ai/update/:id',
    name: 'jAiDetail',
    component: jAiDetail,
    meta: {
      title: 'Update Artificial Intelligence',
      middleware: [auth, admin, log],
      layout: 'jSettingWrapper',
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/jRouterAi.js